import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CallOutcomeService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + "/api/callOutcome";

  callOutcome(Page: number, size: number, sort: any, type: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}&type=${type}`);
  }
  getAllCallOutcomeDropDown(type: any): Observable<Object> {
    return this.http.get(`${this.url}/dropdown?type=${type}`);
  }

  callOutcomeSearch(query: any, Page: any, size: any, sort: any, type: any): Observable<Object> {

    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}&type=${type}`);
  }
  syncCallOutcomePageData() {
    return this.http.get(`${this.url}/page/sync`);
  }

  deleteByCallOutcomeId(statusId: any): Observable<Object> {
    return this.http.delete(`${this.url}/${statusId}`);
  }


  public responseCache = new Map();

  public getAllCallOutcomeDropDownCache(): Observable<any> {

    const callOutcomeFromCache = this.responseCache.get(`${this.url}/dropdown`);

    if (callOutcomeFromCache) {
      return of(callOutcomeFromCache);
    } else {
      return this.http.get<any>(`${this.url}/dropdown`).pipe(
        tap(callOutcome => this.responseCache.set(`${this.url}/dropdown`, callOutcome))
      );
    }

  }


  newCallOutcome(callOutcome: any): Observable<any> {
    return this.http.post<any>(`${this.url}`, callOutcome).pipe(
      tap(() => this.delete())
    );
  }

  delete() {
    this.responseCache.delete(`${this.url}`)
  }


}
